import { Injectable } from '@angular/core';

@Injectable()
export class ViewportService {
    constructor() {

    }

    sizeSm() {
        var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        return w < 600;
    }
}
